// extracted by mini-css-extract-plugin
export var box = "ImageBox-module--box--a5027";
export var free = "ImageBox-module--free--5e6d8";